export interface MasterData {
  readonly cabinClasses: MasterDataItem[];
  readonly passengerTypes: MasterDataItem[];
  readonly genderOptions: MasterDataItem[];
  readonly contactTypes: string[];
  readonly countries: Country[];
}

export interface MasterDataItem {
  readonly key: string | number;
  readonly value: string;
}
export const PassengerTypeEnum = {
  Adult: 1,
  Child: 6,
  Infant: 5,
} as const;

export type PassengerType = 'Adult' | 'Child' | 'Infant';

export const ContactTypeEnum = {
  Email: 'Email',
  MobilePhone: 'MobilePhone',
} as const;

export type ContactType = (typeof ContactTypeEnum)[keyof typeof ContactTypeEnum];

export interface ContactDataType {
  formState: {
    countryCode: string;
    email: string;
    phone: string;
    useForAllPassengers?: boolean;
    passenger?: string[];
  };
  passenger: {
    name: string;
    type: PassengerType;
    typeLabel: string;
  };
}

export interface Country {
  readonly code: string;
  readonly name: string;
  readonly dialCode: string;
  readonly flag: string;
}
export interface UseContactDetailsReturn {
  isEditing: boolean;
  email?: string;
  phone?: string;
  countryCode: string;
  useForAllPassengers?: boolean;
  setEditing: React.Dispatch<React.SetStateAction<boolean>>;
  setCountryCode: (code: string) => void;
  setUseForAllPassengers: (val: boolean) => void;
  handleEmail: (value: string) => void;
  handlePhone: (value: string) => void;
}
